import { CLEAR_DELETE_TOTAL_REPORTS, FETCH_DELETE_TOTAL_REPORTS, LIST_DELETE_TOTAL_REPORTS, CLEAR_DELETE_TOTAL_LOADING } from "./types";

const init = {
    isLoading: false,
    data: {
        items: [],
        summery: {
            "totalTicket": 0,
            "totalAmountKhr": 0,
            "totalAmountUsd": 0
        }

    },
    filter: {}
};
export default (state = init, { type, payload }) => {
    switch (type) {
        case FETCH_DELETE_TOTAL_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_DELETE_TOTAL_REPORTS:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_DELETE_TOTAL_REPORTS:
            return {
                ...init
            };
        case CLEAR_DELETE_TOTAL_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state

    }
}
